
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function SpecialFeatureIndex() {
  return (
    <FSIndex
      data_type="special_feature"
      quick_fields={["special_feature_type"]}
    />
  );
}
